module.exports = __webpack_public_path__ + "static/img/1.d68906a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/UltralowTemperature/R23/1.jpg
// module id = 5uR/
// module chunks = 1